import { useMemo } from 'react';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import Preferences from '@/creditflowresearch/domain/Preferences/Preferences';
import { PreferenceFamily } from '@/creditflowresearch/domain/Preferences/PreferenceSource';
import {
  selectPreferenceQueryParts,
  type IPreferenceQueryParts,
} from '@/creditflowresearch/application/Preferences/selectPreferenceQueryParts';
import UserPlan from '@creditflowresearch/user-plan/UserPlan';
import { EmeaRegion } from '@/creditflowresearch/domain/Region';

export type IEmNavParams = IPreferenceQueryParts;

/** The EM header link's query, taken from saved preferences; each part falls back when unset. */
export const useEmNavParams = (): IEmNavParams => {
  const { preferences, plan, regions: accessibleRegionsIds } = useUserPlanContext();

  return useMemo(() => {
    // TODO: remove when the European market opening period ends; the EM nav link
    // then falls through to the preference mapping below
    if (UserPlan.isStarter(plan) || UserPlan.isUnauthorized(plan)) {
      return { regions: EmeaRegion.ABBREVIATION };
    }

    if (!preferences) {
      return {};
    }

    return selectPreferenceQueryParts(
      new Preferences(preferences),
      { plan, accessibleRegionsIds: accessibleRegionsIds || [] },
      { family: PreferenceFamily.EM },
    );
  }, [preferences, plan, accessibleRegionsIds]);
};
